export default __webpack_public_path__ + "static/hero-mediterranean-7b5e15239ef888c1b363385b6bd91df5.jpg";